import Vue from 'vue'
import App from './App.vue'
import ConfigManager from './plugins/ConfigManager'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ConfigManager)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
